<template>
  <div class="position-relative filter-actions">
    <woot-button
      v-tooltip.right="$t(`CHAT_LIST.SORT_TOOLTIP_LABEL.${sortFilter}`)"
      variant="smooth"
      size="tiny"
      color-scheme="secondary"
      :class="['selector-button', { 'order-active': sortFilter !== 'latest' }]"
      :icon="currentSortIcon"
      @click="toggleDropdown"
    />

    <woot-button
      v-tooltip.right="$t('CHAT_LIST.CAMPAIGN_FILTER')"
      variant="smooth"
      size="tiny"
      color-scheme="secondary"
      class="selector-button margin-left-smaller"
      icon="megaphone"
      @click="toggleCampaignDropdown"
    />

    <woot-button
      v-if="canExportConversations"
      v-tooltip.right="$t('CHAT_LIST.EXPORT_TOOLTIP_LABEL')"
      variant="smooth"
      size="tiny"
      color-scheme="secondary"
      class="selector-button margin-left-smaller"
      icon="archive"
      @click="handleExport"
    />

    <div
      v-if="showActionsDropdown"
      v-on-clickaway="closeDropdown"
      class="dropdown-pane dropdown-pane--open basic-filter"
    >
      <div class="filter__item">
        <span>{{ $t('CHAT_LIST.CHAT_SORT.ORDER_BY') }}</span>

        <filter-item
          type="sort"
          :selected-value="normalizedChatSortFilter"
          :items="chatSortItems"
          path-prefix="CHAT_LIST.CHAT_SORT_FILTER_ITEMS"
          @onChangeFilter="onChangeFilter"
        />
      </div>
    </div>

    <div
      v-if="showCampaignDropdown"
      v-on-clickaway="closeCampaignDropdown"
      class="dropdown-pane dropdown-pane--open campaign-filter"
    >
      <woot-button
        variant="clear"
        size="small"
        :color-scheme="campaignFilter === 'all' ? 'primary' : 'secondary'"
        @click="setCampaign('all')"
      >
        {{ $t('CHAT_LIST.FILTER_ALL_CAMPAIGN') }}
      </woot-button>

      <woot-button
        variant="clear"
        size="small"
        :color-scheme="
          campaignFilter === 'only_campaign' ? 'primary' : 'secondary'
        "
        @click="setCampaign('only_campaign')"
      >
        {{ $t('CHAT_LIST.FILTER_ONLY_CAMPAIGN') }}
      </woot-button>

      <woot-button
        variant="clear"
        size="small"
        :color-scheme="
          campaignFilter === 'without_campaign' ? 'primary' : 'secondary'
        "
        @click="setCampaign('without_campaign')"
      >
        {{ $t('CHAT_LIST.FILTER_WITHOUT_CAMPAIGN') }}
      </woot-button>
    </div>
  </div>
</template>

<script>
import wootConstants from 'dashboard/constants/globals';
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import FilterItem from './FilterItem';
import adminMixin from 'dashboard/mixins/isAdmin';

export default {
  components: {
    FilterItem,
  },
  mixins: [clickaway, adminMixin],
  data() {
    return {
      showActionsDropdown: false,
      showCampaignDropdown: false,
      chatSortItems: this.$t('CHAT_LIST.CHAT_SORT_FILTER_ITEMS'),
    };
  },
  computed: {
    ...mapGetters({
      chatSortFilter: 'getChatSortFilter',
      campaignFilter: 'getCampaignFilter',
    }),
    normalizedChatSortFilter() {
      if (
        this.chatSortFilter === null ||
        this.chatSortFilter === undefined ||
        this.chatSortFilter === 0
      ) {
        return '';
      }

      return String(this.chatSortFilter);
    },
    sortFilter() {
      return this.chatSortFilter || wootConstants.SORT_BY_TYPE.LATEST;
    },
    canExportConversations() {
      return this.isAdmin || this.isSuperAdmin;
    },
    currentSortIcon() {
      if (this.sortFilter === 'latest_first') {
        return 'sort-icon-asc';
      } else if (this.sortFilter === 'latest_old') {
        return 'sort-icon-desc';
      }
      return 'sort-icon';
    }
  },
  methods: {
    onTabChange(value) {
      this.$emit('change-filter', value);
      this.closeDropdown();
    },
    toggleDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    closeDropdown() {
      this.showActionsDropdown = false;
    },
    onChangeFilter(value, type) {
      this.$emit('change-filter', type, value);
      this.closeDropdown();
    },
    toggleCampaignDropdown() {
      this.showCampaignDropdown = !this.showCampaignDropdown;
    },
    closeCampaignDropdown() {
      this.showCampaignDropdown = false;
    },
    setCampaign(value) {
      this.$store.dispatch('setCampaignFilter', value);
      this.$emit('change-filter', 'campaign', value);
      this.closeCampaignDropdown();
    },
    handleExport() {
      if (!this.canExportConversations) return;

      this.$emit('export-conversations');
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-actions {
  display: flex;
  align-items: center;
}

.margin-left-smaller {
  margin-left: var(--space-smaller);
}

.basic-filter {
  margin-top: var(--space-smaller);
  padding: var(--space-normal);
  left: 0;
  width: 21rem;
  z-index: 9999;
  margin-top: 0 !important;
  padding-top: 0 !important;
  top: 30px;

  span {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium);
  }

  .filter__item {
    align-items: center;
    display: flex;
    justify-content: space-between;

    &:last-child {
      margin-top: var(--space-normal);
    }

    span {
      font-size: var(--font-size-mini);
    }
  }
}

.campaign-filter {
  display: flex;
  flex-direction: column;
  gap: var(--space-smaller);
  padding: var(--space-smaller);
  width: 18rem;
  top: 30px;
  z-index: 9999;
}

.order-active {
  color: var(--r-700) !important;
  background-color: var(--r-50) !important;
  border: 1px solid var(--r-700);
}
</style>
